module.exports = "/assets/data/27bbcaa3a3435bbda901b77ab1233708-BT35.data.json";